import { TransactionData } from '@/features/Transactions/transactions.types'

export const MOCK_TRANSACTIONS_ENABLED = false

export const mockTransactions: TransactionData[] = [
  {
    'id': 'DLG_APR--8a87c128-6a35-47ba-821e-1bd5f894101c',
    'solAddress': '8wKLXHwELrbWbfkxJqy2GPPw1fZs9i6Kfq5wfWkdZDGr',
    'splAddress': 'BX1DqwqeMFmeUtuHya9nDoJinUmLU91Lwq46mPtHaRhM',
    'solanaStatus': 'CONFIRMED',
    'status': 'SUCCESS',
    'solanaTxId': 'uCMqzP1puJk9bUbXGDxnKQfjecfFKgCSVNFdeTux95D3AymH1ehPH3tx54fgeBehWzei9yNp8t4VXcCwYEPan2N',
    'data': {
      'type': 'APPROVE_DELEGATE',
      'cryptoAmount': {
        'type': 'CRYPTO',
        'amount': '240.28',
        'symbol': 'USDT',
        'decimals': 6,
        'displayDecimals': 2,
        'mint': 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
        'imageUrl': '/tokens/usdt'
      },
      'fromWalletAddress': '8wKLXHwELrbWbfkxJqy2GPPw1fZs9i6Kfq5wfWkdZDGr',
      'delegationAddress': 'HrgcrV8xhQU58fuNfx8CMvmvwphTj1ZFH5ey3L62xBza',
      'authorityAddress': 'vK6CYMPpd3aqa1N7mQYFX1JWZZJsPPCX2NXyLdUcgt4'
    },
    'failedAt': null,
    'failedReason': null,
    'lastValidBlockHeight': null,
    'validDateTime': null,
    'createdAt': '2026-08-02T22:34:09Z',
    'updatedAt': '2026-08-02T22:34:21Z',
    'displayDateNotSendingTx': null,
    'linkedTransactionId': null
  },
  {
    'id': '4da8e032-d738-4ef5-b1e0-71e36c9a5eb5',
    'solAddress': '8wKLXHwELrbWbfkxJqy2GPPw1fZs9i6Kfq5wfWkdZDGr',
    'splAddress': 'BX1DqwqeMFmeUtuHya9nDoJinUmLU91Lwq46mPtHaRhM',
    'solanaStatus': 'CONFIRMED',
    'status': 'SUCCESS',
    'solanaTxId': '617zGYQHcWrzGw7SpTM9FH7QabK5psDqD4mANnyEs78Teb2kRHn4ppAL1q2MwdvStTCa7gMKn7j7v9kYJ58dcMRv',
    'data': {
      'type': 'CHANGE_BALANCE',
      'cryptoAmount': {
        'type': 'CRYPTO',
        'amount': '199.700000',
        'symbol': 'USDT',
        'decimals': 6,
        'displayDecimals': 2,
        'mint': 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
        'imageUrl': '/tokens/usdt'
      }
    },
    'failedAt': null,
    'failedReason': null,
    'lastValidBlockHeight': null,
    'validDateTime': null,
    'createdAt': '2026-08-02T22:34:01Z',
    'updatedAt': '2026-08-02T22:34:01Z',
    'displayDateNotSendingTx': null,
    'linkedTransactionId': null
  },
  {
    'id': 'CTX-51523fcb-cb3a-4954-905b-ea9d81b51082',
    'solAddress': '8wKLXHwELrbWbfkxJqy2GPPw1fZs9i6Kfq5wfWkdZDGr',
    'splAddress': 'BX1DqwqeMFmeUtuHya9nDoJinUmLU91Lwq46mPtHaRhM',
    'solanaStatus': 'FINALIZED',
    'status': 'SUCCESS',
    'solanaTxId': '3R9SogCpqH8LzUxqheRpQZhzmnSkGZZfrxxQZALXY8TGDg69mnTPaNpmmGbp7nVgcPynUSzQunT22Rux5vFxEr5',
    'data': {
      'type': 'CARD_TRANSACTION',
      'cardTransactionType': 'SPEND',
      'cardId': '8d0042b6-a5ca-4aaf-9b35-7b8f0e256d48',
      'amount': {
        'type': 'CRYPTO',
        'amount': '8.411469',
        'symbol': 'USDT',
        'decimals': 6,
        'displayDecimals': 2,
        'mint': 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
        'imageUrl': '/tokens/usdt'
      },
      'originalAmount': {
        'type': 'FIAT',
        'amount': '3905.00',
        'currency': 'KZT',
        'imageUrl': '/currencies/KZT'
      },
      'cardAmount': {
        'type': 'FIAT',
        'amount': '8.32',
        'currency': 'USD',
        'imageUrl': '/currencies/USD'
      },
      'mcc': '5541 - Service Stations (with or without Ancillary Services)',
      'merchantName': 'HELIOS/AZS 31',
      'lastFourDigits': '1759',
      'merchantIdentifier': 'No',
      'interchangeRate': '469.350962',
      'cryptoChangeRate': '1.000984',
      'feeAmount': '0.083281',
      'imageUrl': '/merchants/default'
    },
    'failedAt': null,
    'failedReason': null,
    'lastValidBlockHeight': null,
    'validDateTime': null,
    'createdAt': '2026-08-02T15:18:22Z',
    'updatedAt': '2026-08-02T15:18:40Z',
    'displayDateNotSendingTx': null,
    'linkedTransactionId': null
  },
  {
    'id': 'CTX-b8d24a45-7725-4cab-a389-b242f55d2cee',
    'solAddress': '8wKLXHwELrbWbfkxJqy2GPPw1fZs9i6Kfq5wfWkdZDGr',
    'splAddress': 'BX1DqwqeMFmeUtuHya9nDoJinUmLU91Lwq46mPtHaRhM',
    'solanaStatus': 'FINALIZED',
    'status': 'SUCCESS',
    'solanaTxId': '4va4TT9VBSeUwrYzTv5vRWwmjmh2gA55P4PmL1NsPXwsctL44HLuEwc6GQwLYYhDgYtW9si94ipVfoAnvW3Yawnd',
    'data': {
      'type': 'CARD_TRANSACTION',
      'cardTransactionType': 'REVERSE',
      'cardId': '8d0042b6-a5ca-4aaf-9b35-7b8f0e256d48',
      'amount': {
        'type': 'CRYPTO',
        'amount': '4.761625',
        'symbol': 'USDT',
        'decimals': 6,
        'displayDecimals': 2,
        'mint': 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
        'imageUrl': '/tokens/usdt'
      },
      'originalAmount': {
        'type': 'FIAT',
        'amount': '2211.37',
        'currency': 'KZT',
        'imageUrl': '/currencies/KZT'
      },
      'cardAmount': {
        'type': 'FIAT',
        'amount': '4.71',
        'currency': 'USD',
        'imageUrl': '/currencies/USD'
      },
      'mcc': 'Quick Payment Service-Fast Food Restaurants',
      'merchantName': 'WOLT.COM',
      'lastFourDigits': '1759',
      'merchantIdentifier': 'No',
      'interchangeRate': '469.505308',
      'cryptoChangeRate': '1.000951',
      'feeAmount': '0.047144',
      'imageUrl': '/merchants/default'
    },
    'failedAt': null,
    'failedReason': null,
    'lastValidBlockHeight': null,
    'validDateTime': null,
    'createdAt': '2026-08-02T12:16:54Z',
    'updatedAt': '2026-08-02T12:17:10Z',
    'displayDateNotSendingTx': null,
    'linkedTransactionId': 'CTX-97e4f5eb-5ec1-4433-b2c4-5b09d6b4b063'
  },
  {
    'id': 'CTX-e3cd70a8-edbe-4aba-a64a-1ea31ad43440',
    'solAddress': '8wKLXHwELrbWbfkxJqy2GPPw1fZs9i6Kfq5wfWkdZDGr',
    'splAddress': 'BX1DqwqeMFmeUtuHya9nDoJinUmLU91Lwq46mPtHaRhM',
    'solanaStatus': 'FINALIZED',
    'status': 'SUCCESS',
    'solanaTxId': '2HmoZJaocsRjnWzMiTvuC7Atzx7RZuW8TksHpGrQhfMQyCQ8q4Srv4zoZQT3Jrd8NbvDqksWVJhNVQxieN3pDxVf',
    'data': {
      'type': 'CARD_TRANSACTION',
      'cardTransactionType': 'SPEND',
      'cardId': '8d0042b6-a5ca-4aaf-9b35-7b8f0e256d48',
      'amount': {
        'type': 'CRYPTO',
        'amount': '20.898162',
        'symbol': 'USDT',
        'decimals': 6,
        'displayDecimals': 2,
        'mint': 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
        'imageUrl': '/tokens/usdt'
      },
      'originalAmount': {
        'type': 'FIAT',
        'amount': '9705.00',
        'currency': 'KZT',
        'imageUrl': '/currencies/KZT'
      },
      'cardAmount': {
        'type': 'FIAT',
        'amount': '20.67',
        'currency': 'USD',
        'imageUrl': '/currencies/USD'
      },
      'mcc': '5812 - Eating Places and Restaurants',
      'merchantName': 'TOO "FARAZ"',
      'lastFourDigits': '1759',
      'merchantIdentifier': 'No',
      'interchangeRate': '469.521045',
      'cryptoChangeRate': '1.001028',
      'feeAmount': '0.206912',
      'imageUrl': '/merchants/default'
    },
    'failedAt': null,
    'failedReason': null,
    'lastValidBlockHeight': null,
    'validDateTime': null,
    'createdAt': '2026-08-02T11:34:43Z',
    'updatedAt': '2026-08-02T11:35:00Z',
    'displayDateNotSendingTx': null,
    'linkedTransactionId': null
  },
  {
    'id': 'CTX-97e4f5eb-5ec1-4433-b2c4-5b09d6b4b063',
    'solAddress': '8wKLXHwELrbWbfkxJqy2GPPw1fZs9i6Kfq5wfWkdZDGr',
    'splAddress': 'BX1DqwqeMFmeUtuHya9nDoJinUmLU91Lwq46mPtHaRhM',
    'solanaStatus': 'FINALIZED',
    'status': 'SUCCESS',
    'solanaTxId': 'EM4Sm8hqgrA58ZUP2TgtZ6oWjf7ypzpk3kQToGfrLxm9TkGuEWm77PSA8EWNvWjGMtjiibGM1S2vZsc4YcHzYov',
    'data': {
      'type': 'CARD_TRANSACTION',
      'cardTransactionType': 'SPEND',
      'cardId': '8d0042b6-a5ca-4aaf-9b35-7b8f0e256d48',
      'amount': {
        'type': 'CRYPTO',
        'amount': '53.735987',
        'symbol': 'USDT',
        'decimals': 6,
        'displayDecimals': 2,
        'mint': 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
        'imageUrl': '/tokens/usdt'
      },
      'originalAmount': {
        'type': 'FIAT',
        'amount': '24951.20',
        'currency': 'KZT',
        'imageUrl': '/currencies/KZT'
      },
      'cardAmount': {
        'type': 'FIAT',
        'amount': '53.15',
        'currency': 'USD',
        'imageUrl': '/currencies/USD'
      },
      'mcc': '5814 - Quick Payment Service-Fast Food Restaurants',
      'merchantName': 'WOLT.COM',
      'lastFourDigits': '1759',
      'merchantIdentifier': 'No',
      'interchangeRate': '469.448731',
      'cryptoChangeRate': '1.001015',
      'feeAmount': '0.532039',
      'imageUrl': '/merchants/default'
    },
    'failedAt': null,
    'failedReason': null,
    'lastValidBlockHeight': null,
    'validDateTime': null,
    'createdAt': '2026-08-02T11:11:31Z',
    'updatedAt': '2026-08-02T11:11:45Z',
    'displayDateNotSendingTx': null,
    'linkedTransactionId': null
  },
  {
    'id': 'CTX-1f7fad28-3707-45e3-b396-a694a9fb33cb',
    'solAddress': '8wKLXHwELrbWbfkxJqy2GPPw1fZs9i6Kfq5wfWkdZDGr',
    'splAddress': 'BX1DqwqeMFmeUtuHya9nDoJinUmLU91Lwq46mPtHaRhM',
    'solanaStatus': 'FINALIZED',
    'status': 'SUCCESS',
    'solanaTxId': '5AGtXS2XmjGihpPPe9arAS1i12QfwS7R6yTQEcUGHmpEs5wmhzcWU9ux4rvQz896XWeTxb5Q6qeH3YXS23eKEd41',
    'data': {
      'type': 'CARD_TRANSACTION',
      'cardTransactionType': 'SPEND',
      'cardId': '8d0042b6-a5ca-4aaf-9b35-7b8f0e256d48',
      'amount': {
        'type': 'CRYPTO',
        'amount': '0.970581',
        'symbol': 'USDT',
        'decimals': 6,
        'displayDecimals': 2,
        'mint': 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
        'imageUrl': '/tokens/usdt'
      },
      'originalAmount': {
        'type': 'FIAT',
        'amount': '450.00',
        'currency': 'KZT',
        'imageUrl': '/currencies/KZT'
      },
      'cardAmount': {
        'type': 'FIAT',
        'amount': '0.96',
        'currency': 'USD',
        'imageUrl': '/currencies/USD'
      },
      'mcc': '5411 - Grocery Stores and Supermarkets',
      'merchantName': 'IP SOLTANKULOVA',
      'lastFourDigits': '1759',
      'merchantIdentifier': 'No',
      'interchangeRate': '468.750000',
      'cryptoChangeRate': '1.001011',
      'feeAmount': '0.009609',
      'imageUrl': '/merchants/default'
    },
    'failedAt': null,
    'failedReason': null,
    'lastValidBlockHeight': null,
    'validDateTime': null,
    'createdAt': '2026-08-02T10:12:35Z',
    'updatedAt': '2026-08-02T10:12:50Z',
    'displayDateNotSendingTx': null,
    'linkedTransactionId': null
  },
  {
    'id': 'CTX-f0d39553-62f6-4099-91e7-9bc8ca8bb7c8',
    'solAddress': '8wKLXHwELrbWbfkxJqy2GPPw1fZs9i6Kfq5wfWkdZDGr',
    'splAddress': 'BX1DqwqeMFmeUtuHya9nDoJinUmLU91Lwq46mPtHaRhM',
    'solanaStatus': 'FINALIZED',
    'status': 'SUCCESS',
    'solanaTxId': '4PXxNBMiK47JP3SMCvDhbW62coo8TWFdEL7MJiHwNqwDLBTsCneXbNw2Qh5o9yhZLsaQxg7ugqti3zhor5PGAg9X',
    'data': {
      'type': 'CARD_TRANSACTION',
      'cardTransactionType': 'SPEND',
      'cardId': '8d0042b6-a5ca-4aaf-9b35-7b8f0e256d48',
      'amount': {
        'type': 'CRYPTO',
        'amount': '22.410062',
        'symbol': 'USDT',
        'decimals': 6,
        'displayDecimals': 2,
        'mint': 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
        'imageUrl': '/tokens/usdt'
      },
      'originalAmount': {
        'type': 'FIAT',
        'amount': '10409.85',
        'currency': 'KZT',
        'imageUrl': '/currencies/KZT'
      },
      'cardAmount': {
        'type': 'FIAT',
        'amount': '22.17',
        'currency': 'USD',
        'imageUrl': '/currencies/USD'
      },
      'mcc': '5814 - Quick Payment Service-Fast Food Restaurants',
      'merchantName': 'GLOVO',
      'lastFourDigits': '1759',
      'merchantIdentifier': 'No',
      'interchangeRate': '469.546685',
      'cryptoChangeRate': '1.000820',
      'feeAmount': '0.221881',
      'imageUrl': '/merchants/default'
    },
    'failedAt': null,
    'failedReason': null,
    'lastValidBlockHeight': null,
    'validDateTime': null,
    'createdAt': '2026-08-01T19:55:30Z',
    'updatedAt': '2026-08-01T19:55:45Z',
    'displayDateNotSendingTx': null,
    'linkedTransactionId': null
  },
  {
    'id': 'CTX-3149d736-c9a4-4d2b-bc45-fc49f15667a6',
    'solAddress': '8wKLXHwELrbWbfkxJqy2GPPw1fZs9i6Kfq5wfWkdZDGr',
    'splAddress': 'BX1DqwqeMFmeUtuHya9nDoJinUmLU91Lwq46mPtHaRhM',
    'solanaStatus': 'FINALIZED',
    'status': 'SUCCESS',
    'solanaTxId': '3nP6jFR93BRS6kt9FrWgEifNhbP6w3s9j9GZVjLn1KniJg1874WXqbYiTecnxvn4x3gMvRpFqAeRSwdnXDCRiZ8f',
    'data': {
      'type': 'CARD_TRANSACTION',
      'cardTransactionType': 'SPEND',
      'cardId': '8d0042b6-a5ca-4aaf-9b35-7b8f0e256d48',
      'amount': {
        'type': 'CRYPTO',
        'amount': '13.597718',
        'symbol': 'USDT',
        'decimals': 6,
        'displayDecimals': 2,
        'mint': 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
        'imageUrl': '/tokens/usdt'
      },
      'originalAmount': {
        'type': 'FIAT',
        'amount': '6317.02',
        'currency': 'KZT',
        'imageUrl': '/currencies/KZT'
      },
      'cardAmount': {
        'type': 'FIAT',
        'amount': '13.45',
        'currency': 'USD',
        'imageUrl': '/currencies/USD'
      },
      'mcc': '5814 - Quick Payment Service-Fast Food Restaurants',
      'merchantName': 'GLOVO',
      'lastFourDigits': '1759',
      'merchantIdentifier': 'No',
      'interchangeRate': '469.666915',
      'cryptoChangeRate': '1.000973',
      'feeAmount': '0.134630',
      'imageUrl': '/merchants/default'
    },
    'failedAt': null,
    'failedReason': null,
    'lastValidBlockHeight': null,
    'validDateTime': null,
    'createdAt': '2026-08-01T10:50:22Z',
    'updatedAt': '2026-08-01T10:50:35Z',
    'displayDateNotSendingTx': null,
    'linkedTransactionId': null
  },
  {
    'id': 'CTX-a0afd6e9-4200-4344-b509-427094d59f15',
    'solAddress': '8wKLXHwELrbWbfkxJqy2GPPw1fZs9i6Kfq5wfWkdZDGr',
    'splAddress': 'BX1DqwqeMFmeUtuHya9nDoJinUmLU91Lwq46mPtHaRhM',
    'solanaStatus': 'FINALIZED',
    'status': 'SUCCESS',
    'solanaTxId': '2oSUYLPaJKdLhvooxdftMTDHACeCjndaPyM3Jhz8Ro8NJ89SYeGRekwQokjt8LayEsMBubsG7etZQdwD3y4mvgf5',
    'data': {
      'type': 'CARD_TRANSACTION',
      'cardTransactionType': 'SPEND',
      'cardId': '8d0042b6-a5ca-4aaf-9b35-7b8f0e256d48',
      'amount': {
        'type': 'CRYPTO',
        'amount': '12.920360',
        'symbol': 'USDT',
        'decimals': 6,
        'displayDecimals': 2,
        'mint': 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB',
        'imageUrl': '/tokens/usdt'
      },
      'originalAmount': {
        'type': 'FIAT',
        'amount': '6000.00',
        'currency': 'KZT',
        'imageUrl': '/currencies/KZT'
      },
      'cardAmount': {
        'type': 'FIAT',
        'amount': '12.78',
        'currency': 'USD',
        'imageUrl': '/currencies/USD'
      },
      'mcc': '5712 - Furniture, Home Furnishings, and Equipment Stores, except Appliances',
      'merchantName': 'IP PRO REMESLO',
      'lastFourDigits': '1759',
      'merchantIdentifier': 'No',
      'interchangeRate': '469.483569',
      'cryptoChangeRate': '1.000973',
      'feeAmount': '0.127924',
      'imageUrl': '/merchants/default'
    },
    'failedAt': null,
    'failedReason': null,
    'lastValidBlockHeight': null,
    'validDateTime': null,
    'createdAt': '2026-08-01T10:40:18Z',
    'updatedAt': '2026-08-01T10:40:35Z',
    'displayDateNotSendingTx': null,
    'linkedTransactionId': null
  }
]
